import styled from "styled-components";
import { P } from "@/lib/styles";

export const Normal = styled(P)`
  margin-bottom: 2.5rem;

  a {
    color: ${({ theme }) => theme.colors.red};
    text-decoration: none;
  }
`;

export const Heading2 = styled.h2`
  font-family: ${({ theme }) => theme.fontFamilies.primary};
  line-height: 1.2;
  margin-bottom: 1rem;
  font-size: 2rem;

  ${({ theme }) => theme.mediaQueries.laptop} {
    font-size: 2.5rem;
  }

  a {
    color: ${({ theme }) => theme.colors.red};
    text-decoration: none;
  }
`;

export const Heading3 = styled.h3`
  font-family: ${({ theme }) => theme.fontFamilies.primary};
  line-height: 1.2;
  margin-bottom: 1rem;
  font-size: 1.75rem;

  ${({ theme }) => theme.mediaQueries.laptop} {
    font-size: 2rem;
  }

  a {
    color: ${({ theme }) => theme.colors.red};
    text-decoration: none;
  }
`;

export const Heading4 = styled.h4`
  margin-bottom: 2.5rem;

  a {
    color: ${({ theme }) => theme.colors.red};
    text-decoration: none;
  }
`;

export const Heading5 = styled.h5`
  margin-bottom: 2.5rem;

  a {
    color: ${({ theme }) => theme.colors.red};
    text-decoration: none;
  }
`;

export const BulletList = styled.ul`
  font-family: ${({ theme }) => theme.fontFamilies.primary};
  font-style: normal;
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 1.2;
  margin-bottom: 2.5rem;
  list-style: initial;
  padding-left: 2rem;

  a {
    color: ${({ theme }) => theme.colors.red};
    text-decoration: none;
  }
  ${({ theme }) => theme.mediaQueries.tablet} {
    font-size: 1.5rem;
  }
`;

export const NumberList = styled.ol`
  font-family: ${({ theme }) => theme.fontFamilies.primary};
  font-style: normal;
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 1.2;
  margin-bottom: 2.5rem;
  list-style: auto;
  padding-left: 2rem;

  a {
    color: ${({ theme }) => theme.colors.red};
    text-decoration: none;
  }
  ${({ theme }) => theme.mediaQueries.tablet} {
    font-size: 1.5rem;
  }
`;

export const DocumentCardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: 16px;

  & > * {
    width: 100%;
    flex: 1 100%;
  }

  ${({ theme }) => theme.mediaQueries.tablet} {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
    margin-top: 0;
  }
  ${({ theme }) => theme.mediaQueries.laptop} {
    & > * {
      flex-basis: calc(50% - 16px);
    }
  }
`;

export const Strong = styled.strong`
  font-weight: 600;
`

export const Span = styled.span<{ $red?: boolean; }>`
  color: ${({ theme, $red }) => $red ? theme.colors.red : theme.colors.black};
`

export const Italic = styled.em`
  font-style: italic;
`

export const Anchor = styled.a`
  border-bottom: 1px solid ${({theme})=>theme.colors.red};
`
